import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import { ToastProvider } from "./components/Toast";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Overview from "./pages/Overview";
import Members from "./pages/Members";
import Spotlight from "./pages/Spotlight";
import Events from "./pages/Events";

function Gate() {
  const { user, loading } = useAuth();

  // Hold the render until the stored token has been checked, otherwise a
  // refresh flashes the login screen before
  
  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "var(--canvas)",
        }}
      >
        <span className="spinner spinner-dark" style={{ width: 26, height: 26, borderWidth: 3 }} />
      </div>
    );
  }

  if (!user) {
    return (
      <Routes>
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Overview />} />
        <Route path="members" element={<Members />} />
        <Route path="spotlight" element={<Spotlight />} />
        <Route path="events" element={<Events />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <Gate />
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}
